import localforage from "localforage";
import { store } from "../app/store";

localforage.config({
  name: "api-collection",
  storeName: "cache",
});

// In-memory cache for synchronous access
let memoryCache: {
  globalState?: any;
  [key: string]: any;
} = {};

export const cacheManager = {
  async init() {
    try {
      const globalState = await localforage.getItem("globalState");
      const mockServers = await localforage.getItem("mockServers");
      if (globalState && Object.keys(globalState).length > 0) {
        memoryCache.globalState = globalState;
        store.dispatch({ type: "globalData/setState", payload: globalState });
      }
      if (mockServers) {
        memoryCache.mockServers = mockServers;
        store.dispatch({ type: "mockServerSlice/setState", payload: mockServers });
      }
    } catch (error) {
      console.error("Error initializing cache:", error);
    }
  },

  // Synchronously get data from memory cache
  getSync(key: string) {
    return memoryCache[key];
  },

  // Get global state synchronously
  getGlobalStateSync() {
    return memoryCache.globalState;
  },

  // Update both IndexedDB and memory cache
  async update(key: string, value: any) {
    try {
      memoryCache[key] = value;
      setTimeout(() => {
        localforage.setItem(key, value).catch((error) => {
          console.error(`Error updating ${key} in IndexedDB:`, error);
        });
      }, 0);
    } catch (error) {
      console.error("Error updating cache:", error);
    }
  },

  // Update global state - with sync memory update for beforeunload
  updateGlobalState(state: any) {
    try {
      // Update memory cache immediately
      memoryCache.globalState = state;

      // Schedule IndexedDB update for after current execution
      setTimeout(() => {
        localforage.setItem("globalState", state).catch((error) => {
          console.error("Error updating global state in IndexedDB:", error);
        });
      }, 0);
    } catch (error) {
      console.error("Error updating global state cache:", error);
    }
  },

  // Clear cache
  async clear() {
    try {
      store.dispatch({ type: "globalData/setState", payload: {} });
      memoryCache = {};
      await localforage.clear();
    } catch (error) {
      console.error("Error clearing cache:", error);
    }
  },

  // Check if an item needs to be fetched from API
  shouldFetchFromAPI(cachedData: any) {
    if (!cachedData) return true;

    const timestamp = cachedData.timestamp;
    if (!timestamp) return true;

    // Cache for 5 minutes
    const CACHE_DURATION = 5 * 60 * 1000;
    return Date.now() - timestamp > CACHE_DURATION;
  },

  // Add timestamp to cached data
  addTimestampToData(data: any) {
    return {
      ...data,
      timestamp: Date.now(),
    };
  },
};

// Export singleton instance
export default cacheManager;
